import ROUTES from "@consts/routes";
import i18n from "@/lang/i18n";

export default [
  {
    path: 'analysis',
    name: ROUTES.CS.ANALYSIS,
    meta: {breadcrumb: i18n.tc('breadcrumbs.Analysis'), activeKey: 'cs.analysis'},
    component: () => import("@components/cs/analysis/Analysis"),
  },
];
